import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const button = {
  createButton: lazyModuleMethod(() => import('./createButton'), 'default'),
  deleteButton: lazyModuleMethod(() => import('./deleteButton'), 'default'),
  fetchButton: lazyModuleMethod(() => import('./fetchButton'), 'default'),
  fetchButtons: lazyModuleMethod(() => import('./fetchButtons'), 'default'),
  updateButton: lazyModuleMethod(() => import('./updateButton'), 'default'),
}
